import { useContext } from "react";
import { useMutation } from "@apollo/client";

import { UserDispatchContext } from "../../../Contexts/User/context";
import { gql } from "@apollo/client";
import { useUser } from "../../User/User.hook";

const SEEN_MUTATION = gql`
	mutation seen($property_id: ID! , $type:PropEntityType) {
		addVisitHistory(property_id: $property_id, type: $type) {
			id
			history {
				property_id
			}
		}
	}
`;

export function useSeenStatus({ id }) {
	const {
		user: { data, loading, error },
	} = useUser();

	const result = data?.me?.history?.some(e => e.property_id == id);

	return { loading, result, error };
}

export function useMarkSeen() {
	const dispatch = useContext(UserDispatchContext);
	const [mutation, { data, loading, called }] = useMutation(SEEN_MUTATION, {
		onCompleted: d => {
			if (!!d?.addVisitHistory?.history)
				dispatch({ type: "merge", payload: { history: d.addVisitHistory.history } });
		},
		onError: x => console.log("useMarkSeen no puede marcar como vista la prop", x),
	});

	const markSeen = (
		property_id?: string | number | null,
		type: ListingType = "PROPERTY"
	) => {
		if (property_id == null || property_id === "") {
			console.warn("useMarkSeen recibió property_id vacío", { property_id, type });
			return Promise.resolve(null);
		}

		return mutation({ variables: { property_id, type } });
	};

	return { markSeen, loading, data, called };
}
